import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { loadWidget, changeWidgetJSProp, opentTab, resetSelectedWidget, setTemplate, loadWidgets } from '../actions';
import { EDITOR } from '../constants';
import { fetchTemplateById } from 'dash-front/actions';
import { BottomNavigation, BottomNavigationItem } from 'material-ui/BottomNavigation';
import IconLayers from 'material-ui/svg-icons/maps/layers';
import IconWidgets from 'material-ui/svg-icons/device/widgets';
import IconSettings from 'material-ui/svg-icons/action/settings-applications';
import IconBack from 'material-ui/svg-icons/navigation/chevron-left';
import WidgetImageManipulations from './WidgetImageManipulations';
import WidgetDataManipulations, { uiFilter, commonFilter } from './WidgetDataManipulations';
import IconNext from 'material-ui/svg-icons/navigation/chevron-right';
// import PreviewAndVariations from './PreviewAndVariations';
import Layouts, { LayoutsImagesList } from './WidgetLayouts';
import PreviewAndVariations from './PreviewAndVariations';
// import WidgetEmbed from './WidgetEmbed';
import _ from 'lodash';
// import EditorStandartLayout from './controls/EditorStandartLayout';
import FlatButton from 'material-ui/FlatButton/FlatButton';
import { Scrollbars } from 'react-custom-scrollbars';
import FastImagePicker from '../containers/FastImagePicker';

import IMControls from './controls/IMControls';
import PickerSwitcher from '../pickers/components/PickerSwitcher';

const WidgetDataTab = () => (
    <div style={{ margin: '0 12px' }}>
        <WidgetDataManipulations title="Data selection" expanded />
        <WidgetDataManipulations title="Look & feel" filter={uiFilter} expanded />
        <WidgetDataManipulations title="Common" filter={commonFilter} />

        {/* <WidgetDataManipulations title="ALL (to kill)" filter={() => true} /> */}
        {/* <WidgetDataManipulations title="Advanced" filter={advancedFilter} /> */}
        <div style={{ display: 'none' }}>
            <WidgetImageManipulations />
        </div>
    </div>
);

const WidgetIMTab = () => (
    <div style={{ margin: 12 }}>
        <WidgetImageManipulations />
    </div>
);

const TABS = [
    [EDITOR.TABS.LAYOUT, IconWidgets, LayoutsImagesList, 'Layout'],
    [EDITOR.TABS.PARAMS, IconSettings, WidgetDataTab, 'Data'],
    [EDITOR.TABS.IMAGE_MANIPULATIONS, IconLayers, WidgetIMTab, 'Images'],
];

const openV2PostDialogue = (e, widgetId, widgetProps) => {
    const schedulePost = JSON.stringify({
        widgetId,
        widgetProps,
    });
    localStorage.setItem('schedule_post', schedulePost);
    window.location.href = '/v2/calendar?calendarView=month';
};

function WidgetEditor({
    tab,
    opentTab,
    widgetId,
    template,
    resetSelectedWidget,
    allowChangeWidget = false,
    onChangeWidgetRequest,
    mainAction,
    widgetProps,
}) {
    const seletedTab = TABS.find(([key]) => key === tab);
    let LeftComponent;
    if (seletedTab) LeftComponent = seletedTab[2];

    return (
        <div style={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>
            <div
                style={{
                    maxWidth: 280,
                    minWidth: 280,
                    height: '100vh',
                    position: 'relative',
                    display: 'flex',

                    flexDirection: 'column',
                    background: 'rgba(0,0,0,0.2)',
                    borderRight: '1px solid rgba(0,0,0,0.2)',
                }}
            >
                <div>
                    {allowChangeWidget && (
                        <FlatButton
                            icon={<IconBack />}
                            style={{ height: 40 }}
                            label="Change Widget"
                            onClick={() => {
                                if (onChangeWidgetRequest) onChangeWidgetRequest();
                                resetSelectedWidget();
                            }}
                        />
                    )}

                    <div style={{ background: '#20272d', display: 'flex', flexDirection: 'row' }}>
                        <BottomNavigation selectedIndex={TABS.findIndex(([key]) => key === tab)}>
                            {TABS.map(([action, Icon, , label]) => (
                                <BottomNavigationItem
                                    key={action}
                                    style={{ ...(action === tab ? { background: '#000' } : {}) }}
                                    label={label}
                                    icon={<Icon />}
                                    onClick={() => opentTab(action)}
                                />
                            ))}
                        </BottomNavigation>
                    </div>
                </div>

                <Scrollbars style={{ flexGrow: 1 }}>
                    {/* <div style={{ margin: 10, height: 3000, background: 'yellow' }} /> */}
                    <LeftComponent template={template} />
                </Scrollbars>
                <h5
                    style={{
                        textAlign: 'center',
                        color: '#00505b',
                        bottom: 0,
                        width: '100%',
                        zIndex: 100,
                        margin: 0,
                        lineHeight: '50px',
                        background: '#000',
                    }}
                >
                    SPORTSINNOVATION
                </h5>
            </div>

            <div style={{ alignSelf: 'stretch', width: '100%', height: '100vh', overflow: 'auto' }}>
                {/* RIGHT */}
                {tab === 'layout' ? <Layouts /> : null}
                {tab === 'data' && widgetId ? (
                    <PreviewAndVariations
                        label="Step 2."
                        text="Select data"
                        mainAction={
                            <FlatButton
                                label="Step 3: Image manipulations"
                                style={{ height: 48 }}
                                backgroundColor="#008c9c"
                                color="#fff"
                                hoverColor="#007c8a"
                                labelPosition="before"
                                icon={<IconNext />}
                                onClick={() => {
                                    opentTab('im');
                                }}
                            />
                        }
                    />
                ) : null}
                {tab === 'im' && widgetId ? (
                    <PreviewAndVariations
                        label="Step 3."
                        text="Manipulate images"
                        mainAction={
                            <FlatButton
                                label={_.get(mainAction, 'text', 'PREVIEW & PUBLISH')}
                                style={{ height: 48 }}
                                backgroundColor="#008c9c"
                                color="#fff"
                                hoverColor="#007c8a"
                                labelPosition="before"
                                icon={<IconNext />}
                                onClick={e => {
                                    ((mainAction && mainAction.onClick) || openV2PostDialogue)(
                                        e,
                                        widgetId,
                                        widgetProps,
                                        template,
                                    );
                                    this.props.resetSelectedWidget();
                                }}
                            />
                        }
                    />
                ) : null}
            </div>

            <div
                style={{
                    maxWidth: 280,
                    minWidth: 280,
                    height: '100vh',
                    position: 'relative',
                }}
            >
                <Scrollbars>
                    <div
                        style={{
                            height: '100%',
                            position: 'relative',
                            display: 'flex',
                            padding: 12,
                            paddingTop: 96,
                            flexDirection: 'column',
                            background: 'rgba(0,0,0,0.2)',
                            borderRight: '1px solid rgba(0,0,0,0.2)',
                        }}
                    >
                        <div style={{ background: '#000', padding: 12, margin: -12 }}>
                            <IMControls />
                        </div>

                        <PickerSwitcher type="dialog" />
                        <FastImagePicker />
                    </div>
                </Scrollbars>
            </div>
        </div>
    );
}

const WidgetEditorEnhanced = compose(
    connect(
        ({ editor }, { widgetId, template, widgetProps, tab }) => {
            return {
                preview: editor.preview,
                previewError: editor.previewError,
                widgetId: editor.widgetId || widgetId, // SHIT
                widgetProps: editor.widgetProps || widgetProps,
                tab: editor.tab || tab || 'layout',
                template: editor.template || template,
            };
        },
        {
            loadWidget,
            loadWidgets,
            fetchTemplateById,
            changeWidgetJSProp,
            opentTab,
            setTemplate,
            resetSelectedWidget,
        },
    ),
    lifecycle({
        componentWillReceiveProps(nextProps) {
            if (this.props.widgetId !== nextProps.widgetId) {
                if (nextProps.widgetId) {
                    this.props.loadWidget(nextProps.widgetId, nextProps.widgetProps); // keep params
                    //For widget layouts
                    //for possibility of disabling widget layout for the user
                    this.props.loadWidgets();
                }
            }

            if (this.props.template !== nextProps.template) {
                console.log('HO', nextProps.template, this.props.template);
                this.props.setTemplate(nextProps.template);
            }
            if (this.props.tab !== nextProps.tab) {
                this.props.opentTab(nextProps.tab);
            }
        },
        componentWillUnmount() {
            this.props.resetSelectedWidget();
        },
        componentDidMount() {
            const { widgetId, widgetProps, template, tab } = this.props;

            if (widgetId) {
                console.log('HOO');
                this.props.loadWidget(widgetId, widgetProps);
                this.props.setTemplate(template);
            } else {
                this.props.resetSelectedWidget();
            }

            if (tab) this.props.opentTab(tab);
        },
    }),
)(WidgetEditor);

export default WidgetEditorEnhanced;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/WidgetEdit.js
 **/